import { useState } from "react";

/**
 * @typedef {Object} LoadingContext
 * @property {boolean} loadingFlag - The loading flag.
 * @property {function(boolean): void} setLoadingFlag - The function to set the loading flag.
 * @property {function(() => void): Promise<void>} loadingCb - The function to set the loading flag to true, execute the callback, and set the loading flag to false.
 */

const useLoading = () => {
    const [loadingFlag, setLoadingFlag] = useState(false);

    /**
     * This function is used to set the loading flag to true, execute the callback, and set the loading flag to false.
     * @param {async () => void} callback - The callback function.
     */
    const loadingCb = async (callback) => {
        setLoadingFlag(true);
        await callback();
        setLoadingFlag(false);
    };

    return { loadingCb, loadingFlag, setLoadingFlag };
};
export default useLoading;
